import { Download, Loader2 } from "lucide-react";
import TabelaFiscal, { CABECALHO_FIXO, CELULA_FIXA } from "../../_components/tabela-fiscal";
import Badge from "../../_components/badge";
import { STATUS } from "../../status";

const COLUNAS = [
	{ rotulo: "Série", classe: "text-center w-16" },
	{ rotulo: "Número", classe: "text-center w-24" },
	{ rotulo: "Mês", classe: "text-center w-24" },
	{ rotulo: "Chave de acesso", classe: "text-left" },
	{ rotulo: "Situação", classe: "text-center w-32" },
	{ rotulo: "", classe: `text-center w-36 ${CABECALHO_FIXO}` },
];

const FACA_UMA_PESQUISA = "Utilize o botão Listar para consultar na SEFAZ as NFC-e do período.";
const NENHUMA_NOTA = "A SEFAZ não tem NFC-e desta empresa no período.";

function mesDe(mes) {
	const [ano, numero] = mes.split("-");
	return `${numero}/${ano}`;
}

export default function TabelaSefaz({ chaves, total, pagina, totalPaginas, onPagina, carregando, jaBuscou, situacoes, baixando, onBaixar }) {
	return (
		<TabelaFiscal
			colunas={COLUNAS}
			total={total}
			pagina={pagina}
			totalPaginas={totalPaginas}
			onPagina={onPagina}
			carregando={carregando}
			vazio={jaBuscou ? NENHUMA_NOTA : FACA_UMA_PESQUISA}
		>
			{chaves.map((item) => {
				const { chave, serie, numero, mes } = item;

				return (
					<tr key={chave} className="group hover:bg-customBlue-primary/5">
						<td className="text-center align-middle text-sm text-gray-500">{serie}</td>
						<td className="text-center align-middle font-semibold text-gray-800">{numero}</td>
						<td className="text-center align-middle text-sm">{mesDe(mes)}</td>
						<td className="text-left align-middle font-mono text-xs text-gray-600">{chave}</td>
						<td className="text-center align-middle">
							{situacoes[chave] ? <Badge {...STATUS[situacoes[chave]]} /> : <span className="text-gray-400">—</span>}
						</td>
						<td className={`align-middle text-center ${CELULA_FIXA}`}>
							<button
								type="button"
								disabled={!!baixando}
								onClick={() => onBaixar(item)}
								className="btn btn-sm btn-outline-primary inline-flex items-center gap-1.5 whitespace-nowrap"
							>
								{baixando === chave ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}
								Baixar XML
							</button>
						</td>
					</tr>
				);
			})}
		</TabelaFiscal>
	);
}
